import { render, staticRenderFns } from "./CmgCharitableDonation.vue?vue&type=template&id=8d28d906&scoped=true&lang=pug&"
import script from "./cmg-charitable-donation.ts?vue&type=script&lang=ts&"
export * from "./cmg-charitable-donation.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCharitableDonation.vue?vue&type=style&index=0&id=8d28d906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d28d906",
  null
  
)

export default component.exports